export const config = {
  adminGoogleClientId: '268137627072-s0889vrrko1ft9pu45ne473msil9tepp.apps.googleusercontent.com',
  apiGoogleClientId: '1059605434519-o5f19p5v14sa9fd9ue1oe0rbp68lkd3g.apps.googleusercontent.com',
};